import { render, staticRenderFns } from "./ProfilePassword.vue?vue&type=template&id=501f6469&"
import script from "./ProfilePassword.vue?vue&type=script&lang=js&"
export * from "./ProfilePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501f6469')) {
      api.createRecord('501f6469', component.options)
    } else {
      api.reload('501f6469', component.options)
    }
    module.hot.accept("./ProfilePassword.vue?vue&type=template&id=501f6469&", function () {
      api.rerender('501f6469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/profile/ProfilePassword.vue"
export default component.exports